import { ProjectStatus } from '../types/projects';
import { Calendar, PlayCircle, CheckCircle } from 'lucide-react';
import React from 'react';

/**
 * Get Bootstrap badge variant for project status
 */
export const getStatusBadgeVariant = (status: ProjectStatus): string => {
    switch (status) {
        case ProjectStatus.PLANNED:
            return 'secondary';
        case ProjectStatus.IN_PROGRESS:
            return 'primary';
        case ProjectStatus.COMPLETED:
            return 'success';
        default:
            return 'secondary';
    }
};

/**
 * Get CSS color for project status (for dropdowns and other UI elements)
 */
export const getStatusColor = (status: ProjectStatus): string => {
    switch (status) {
        case ProjectStatus.PLANNED:
            return '#7F909F';
        case ProjectStatus.IN_PROGRESS:
            return '#28aede';
        case ProjectStatus.COMPLETED:
            return '#188754';
        default:
            return '#7F909F';
    }
};

/**
 * Get icon component for project status
 */
export const getStatusIcon = (status: ProjectStatus): React.ReactNode => {
    switch (status) {
        case ProjectStatus.PLANNED:
            return <Calendar size={16} className="me-1" />;
        case ProjectStatus.IN_PROGRESS:
            return <PlayCircle size={16} className="me-1" />;
        case ProjectStatus.COMPLETED:
            return <CheckCircle size={16} className="me-1" />;
        default:
            return null;
    }
};

/**
 * Get label text for project status
 */
export const getStatusLabel = (status: ProjectStatus): string => {
    return status; // Status enum values are already in Swedish
};

